import type { Components } from '@mui/material/styles';

export default function MUIButtonBase(): Components['MuiButtonBase'] {
  return {
    defaultProps: {
      color: 'neutral',
    },
  };
}
